import { mergeObjectTypes } from '../cacheHelpers';

const Carriage = {
  merge: mergeObjectTypes
};

export default Carriage;
